import BigNumber from "bignumber.js";

import { CadenceTypes } from "types/enums";

// Calculate the cost of the subscription based on the cadence and quantity
export const getCost = (
	billingCadence: string,
	qty: number | string,
	defaultPrice: any,
) => {
	let price = 0;
	const quantity = +qty;

	if (
		billingCadence === CadenceTypes.Monthly.name &&
		(typeof defaultPrice.monthly === "number" ||
			typeof defaultPrice.monthly === "string")
	) {
		price = defaultPrice.monthly;
	} else if (billingCadence === CadenceTypes.Monthly.name && quantity === 1) {
		price = defaultPrice.monthly.one;
	} else if (billingCadence === CadenceTypes.Monthly.name && quantity > 1) {
		price = defaultPrice.monthly.several;
	} else if (billingCadence === CadenceTypes.Annually.name) {
		price = defaultPrice.annually;
	} else if (billingCadence === CadenceTypes.OneTime.name) {
		price = defaultPrice.oneTime;
	}

	const cost = new BigNumber(price);
	const finalCost = cost.multipliedBy(qty);

	return finalCost.toNumber();
};
